const AboutUs = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 via-blue-50 to-white">
      
      {/* Hero Section */}
      <section className="pt-36 pb-16 lg:pt-40 lg:pb-24">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Content */}
            <div>
              <h1 className="text-4xl lg:text-5xl font-bold text-blue-500 mb-6 leading-tight">
                About <span className="text-gray-900">Us</span>
              </h1>
              
              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                iSolve RCM is the trusted medical billing company for providers of all sizes. With years of experience in healthcare IT and billing, our healthcare revenue specialists deliver accurate billing and coding services that reduce claim denials and improve reimbursement.
              </p>

              <button className="bg-blue-800 hover:bg-blue-700 text-white font-bold px-8 py-4 rounded-lg transition-colors shadow-lg">
                Contact Us
              </button>
            </div>

            {/* Right Image with Stats */}
            <div className="relative flex justify-center lg:justify-end">
              <img 
                src="/billing6.jpg" 
                alt="Healthcare Team" 
                className="w-full max-w-lg rounded-3xl"
              />
              
             
            </div>

          </div>
        </div>
      </section>

      {/* WHO WE ARE Section */}
      <section className="py-12 lg:py-16 bg-white">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Image */}
            <div className="relative">
              <img 
                src="/billing10.jpg" 
                alt="Medical Billing Process" 
                className="w-full rounded-3xl shadow-xl"
              />
              
              
            </div>

            {/* Right Content */}
            <div>
              <div className="text-blue-500 text-sm font-semibold mb-2 uppercase tracking-wider">
                WHO WE ARE
              </div>
              
              <h2 className="text-3xl lg:text-4xl font-bold mb-4 leading-tight">
                <span className="text-blue-500">From Patient Registration to Payment |</span>{' '}
                <span className="text-gray-900">Our Experts Handle It All Seamlessly</span>
              </h2>
              
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                Our team of professionals precisely and carefully monitors each step of the revenue cycle, from the moment that a patient registers until their payment is received. Medical billing, credentialing, patient onboarding, charge entry, and clean claim submission are just a few of the various solutions that iSolve RCM delivers. To keep your medical practice working smoothly and the revenue coming regularly, we also handle denials, A/R follow-up, and telehealth billing. Our objective is to free you of the administrative burden so you can focus on providing exceptional customer service.
              </p>

              <p className="text-base text-gray-700 leading-relaxed">
                We enable your practice in maintaining compliance, avoiding costly errors, and improving communication with insurance payers alongside your routine billing operations. Our services are personalized to your practice size and area of specialty, providing you with a billing process that effectively matches your workflow. Furthermore, you get the benefit of comprehensive reporting so you can track your financial health with ease.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* Whom We Serve Section */}
      <section className="py-10 lg:py-14 bg-gray-50">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
          
          <h2 className="text-3xl lg:text-4xl font-bold text-center mb-8 leading-tight">
            <span className="text-blue-500">Whom</span>{' '}
            <span className="text-gray-900">We Serve</span>
          </h2>
          
          <p className="text-base text-gray-700 leading-relaxed text-center max-w-6xl mx-auto">
            As a leading source for medical billing services in USA, we have made a lot of things easy for healthcare professionals. Whether you're a solo physician spending most of your time with patients, a group practice looking to streamline operations, or a specialty clinic in fields like cardiology, orthopedics, or dermatology, we will simplify your billing processes. Our services extend to hospitals to ensure an efficient RCM for large-scale operations and ambulatory surgery centers (ASCs), helping maximize reimbursements with accurate, timely billing. Partner with us to save time, reduce costs, and achieve consistent revenue growth.
          </p>

        </div>
      </section>

      {/* Our Mission & Value Section */}
      <section className="py-12 lg:py-16 bg-white">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Side - Image */}
            <div className="flex justify-center order-2 lg:order-1">
              <img 
                src="/billing7.webp" 
                alt="Our Mission and Value" 
                className="w-full max-w-md h-[500px] object-cover rounded-3xl shadow-xl"
              />
            </div>

            {/* Right Side - Mission & Value */}
            <div className="space-y-8 sm:space-y-12 order-1 lg:order-2">
              
              {/* Our Mission */}
              <div>
                <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
                  <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-blue-500">
                    Our <span className="text-gray-900">Mission</span>
                  </h2>
                  <svg className="w-8 h-8 sm:w-10 sm:h-10 text-blue-600 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                  </svg>
                </div>
                
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Our mission is to provide comprehensive billing and revenue cycle management (RCM) solutions that maximize collections, accelerate cash flow, improve efficiency, minimize medical billing denials, and reduce administrative costs. Designed for healthcare providers, doctors, clinics, and specialty practices, our services are powered by experienced medical billers and advanced technology to deliver visible results and build stronger healthcare operations.
                </p>
              </div>

              {/* Our Value */}
              <div>
                <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
                  <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-blue-500">
                    Our <span className="text-gray-900">Value</span>
                  </h2>
                  <svg className="w-8 h-8 sm:w-10 sm:h-10 text-blue-600 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                  </svg>
                </div>
                
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  We believe in teamwork, and it's what allows us to deliver accurate revenue cycle management, which helps healthcare providers achieve their financial goals. We believe in continuous improvement and ensure better outcomes. We deal with our clients with honesty and transparency. Our commitment to excellence proves that we care about your success. We leverage new ideas and technology to improve accuracy and maximize collections.
                </p>
              </div>

            </div>

          </div>
        </div>
      </section>

      {/* Our Resources Section */}
      <section className="py-8 lg:py-12 bg-gray-50">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
          
          <h2 className="text-3xl lg:text-4xl font-bold text-center mb-4 leading-tight">
            <span className="text-blue-500">Our</span>{' '}
            <span className="text-gray-900">Resources</span>
          </h2>
          
          <p className="text-base text-gray-700 text-center mb-8">
            Find what you need, quickly and easily.
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <button className="px-8 py-3 bg-white border-2 border-gray-300 text-gray-700 font-semibold rounded-lg hover:border-blue-500 hover:text-blue-600 transition-all">
              RCM Services
            </button>
            <button className="px-8 py-3 bg-white border-2 border-gray-300 text-gray-700 font-semibold rounded-lg hover:border-blue-500 hover:text-blue-600 transition-all">
              Medical Specialties
            </button>
            <button className="px-8 py-3 bg-white border-2 border-gray-300 text-gray-700 font-semibold rounded-lg hover:border-blue-500 hover:text-blue-600 transition-all">
              States We Serve
            </button>
          </div>

        </div>
      </section>

      {/* Ready to Connect Section */}
      <section className="py-8 lg:py-12">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="bg-gradient-to-r from-blue-900 to-blue-700 rounded-3xl p-12 lg:p-16 text-center shadow-2xl">
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
              Ready to connect?
            </h2>
            
            <p className="text-lg text-white/90 mb-8">
              Let's connect and find a time that works best for you.
            </p>

            <button className="bg-white text-blue-900 font-bold px-8 py-4 rounded-lg hover:bg-gray-100 transition-colors shadow-lg inline-flex items-center gap-2">
              Schedule 1 : 1 meeting
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>

        </div>
      </section>

    </div>
  );
};

export default AboutUs;
